import React from 'react'

const Separator = () => {
  return (
    <div className="w-full h-[3px] bg-primary/60 my-[5rem] rounded-full dark:bg-primary"></div>
  )
}

export default Separator